<div class="full-menu-header-container container" id="headerFullMenu">
  <div class="rectangle-header-result">
    <div class="title-result">
      <span id="menuTitle" class="title-text itau-text-bold">{{ title + ".TRANSLATION" | translate }}</span>
    </div>
    <div class="subtitle-result">
      <div class="subtitle-text">
        <span id="menuDescription" class="subtitle-text">{{ "menuDescription.TITLE" | translate }} {{ title + ".TRANSLATION" | translate }}</span>
      </div>
      <div class="subtitle-order">
        <app-full-menu-order [menu]="categoryMenu" (newMenu)="onMenuChange($event)"> </app-full-menu-order>
      </div>
    </div>
  </div>
</div>
